import Utils from '../../components/utils';
import Modal from '../../components/Modal';
import Vars from '../../vars';

class Validation {
    constructor (args) {
        let self = this;

        self._setArgs(args);
        self._init();
    }

    _elems = {
        $_      : $(),
        $input  : $(),
        $select : $()
    };

    _setArgs = (args) => {
        let self = this;

        self._elems.$_ = args.form;
    };

    _bindElements = () => {

        let self = this;

        if (!self._elems.$_.length) return;

        self._elems.$input  = self._elems.$_.find('input');
        self._elems.$select = self._elems.$_.find('select');
    };

    _bindUI = () => {

        let self = this;

        if (!self._elems.$_.length) return;

        self._elems.$input.length && self._elems.$input.keyup(function(){
            if ($(this).attr('required') === 'required' || $(this).parents('.form-field').hasClass('required')) {
                if ($(this).val() != '') {
                    $(this).parents('.form-field').removeClass('error');
                    $(this).parent().next('.form-field__message').text('').hide();
                } else {
                    $(this).parents('.form-field').addClass('error');
                    $(this).parent().next('.form-field__message').text('Поле обязательно для заполнения').show();
                }
            }
            if ($(this).parent().hasClass('float')) {
                if ($(this).val().match(/^\d+/) != null || $(this).val() == '') {
                    $(this).parents('.form-field').removeClass('error');
                    $(this).parent().next('.form-field__message').text('').hide();
                } else {
                    $(this).parents('.form-field').addClass('error');
                    $(this).parent().next('.form-field__message').text('Поле имеет ошибочный формат').show();
                }
            }
            if ($(this).attr('type') == 'number') {
                if ($(this).val().match(/^\d+/) != null || $(this).val() == '') {
                    $(this).parents('.form-field').removeClass('error');
                    $(this).parent().next('.form-field__message').text('').hide();
                } else {
                    $(this).parents('.form-field').addClass('error');
                    $(this).parent().next('.form-field__message').text('Поле имеет ошибочный формат').show();
                }
            }
        });

        self._elems.$select.length && self._elems.$select.change(function(){
            if ($(this).attr('required') === 'required' || $(this).parents('.form-field').hasClass('required')) {
                if ($(this).val() != '') {
                    $(this).parents('.form-field').removeClass('error');
                    $(this).parent().next('.form-field__message').text('').hide();
                }
            }
        });
    };

    _init = () => {
        let self = this;

        self._bindElements();
        self._bindUI();
    };

    showErrors = (error) => {
        let self = this;

        if (!self._elems.$_.length) return;

        if (error.type === Vars.errors.types.validation){
            self._elems.$_.find('.form-field[data-name]').each(function() {
                $(this).removeClass('error');
                $(this).find('.form-field__message').hide().addClass('hidden');
            });

            Object.keys(error.fields).forEach(function(fieldName) {
                if (fieldName == 'address_element_id') {
                    self._elems.$_.find('.form-field[data-name="address"]').each(function(){
                        let $field = $(this);
                        $field.addClass('error');

                        $field.find('.form-field__message').each(function() {
                            $(this).removeClass('hidden').show().html('Адрес необходимо выбрать из выпадающего списка');
                        });
                    })
                }
                self._elems.$_.find('.form-field[data-name=' + fieldName.replace(/\./g, '\\.')  + '], .form-field__wrapper[data-name=' + fieldName.replace(/\./g, '\\.')  + ']').each(function() {
                    let $field = $(this);
                    $field.addClass('error');

                    if ($field.parents('.form-slider').length) {
                        $field.parents('.form-slider').addClass('open');
                    }

                    if (!$field.find('.form-field__message').length) {
                        $field.append(
                            $('<div />')
                                .addClass('form-field__message')
                        )
                    }
                    $field.find('.form-field__message').each(function() {
                        $(this).removeClass('hidden').show().html(error.fields[fieldName].join('<br />'));
                    });
                });
            });

            let firstFieldName = Object.keys(error.fields)[0].replace(/\./g, '\\.');
            let $first = self._elems.$_.find('.form-field[data-name=' + firstFieldName + ']').find('input, select');
            $first.focus();

        }
        else {
            let title = 'Ошибка';
            if (error.type === Vars.errors.types.notFound) {
                title += '404';
            }
            else if (error.type === Vars.errors.types.permissionDenied) {
                title += 'Доступ запрещен';
            }
            else if (error.type === Vars.errors.types.auth) {
                title += 'Ошибка авторизации';
            }

            new Modal({
                title   : title,
                content : Utils.renderProfileTemplate('error', {
                    error   : error,
                    buttons : null
                })
            });
        }
    }
}

export default Validation;